import React from 'react';
import { useLoaderData } from '@tanstack/react-router';

import DashboardShares from './Shares';

import MemoryType from '../Memory/Type';

const DashboardMemory: React.FC = () => {
  const { memory } = useLoaderData({ strict: false });
  console.log(memory);

  if (!memory) {
    return null;
  }

  return (
    <>
      <div className="dashboard-header page-header">
        <MemoryType memory={memory} style="simple" />
        <h2 className="page-title">
          {memory.title}
        </h2>
      </div>
      <div className="dashboard-memory wa-stack wa-gap-0">
        <DashboardShares memory={memory} />
      </div>
    </>
  );
}

export default DashboardMemory;
